import React from "react";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import styles from './Footer.module.css';
import logo from '../img/logo.png';
import instagram from '../img/instagram.png';

function Footer() {
  return (
    <footer className={`${styles.footerStyle} py-5`}>
      <Container>
        {/* SECTION 1: Brand header with logo and name aligned horizontally */}
        <Row className={styles.footerRow}>
          <Col lg="12" className={`text-center mb-4 d-flex ${styles.colFirstRow} mt-2`}>
              <img 
                src={logo} 
                alt="logo" 
                className={styles.logo} 
              />
              <h4>
                Isabelle Conrozier Kassovic
              </h4>
          </Col>
        </Row>

        {/* SECTION 2: Horizontal Contact and Social links */}
        <Row className={styles.footerRow}>
          <Col lg="12">
            <Nav className={`${styles.linksList} justify-content-center mb-4`}>
              <NavItem>
                <NavLink href="mailto:i.conrozier@orange.fr" className={styles.footerLinks}>
                  i.conrozier@orange.fr
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="tel:0684988078" className={styles.footerLinks}>
                  06.84.98.80.78
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink 
                  href="https://www.instagram.com/ickasso_art/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.footerLinks}
                >
                  <img src={instagram} alt="Instagram" style={{ width: "20px", marginRight: "5px" }} />
                  Suivez-moi sur instagram : IcKasso_art
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>

        <hr />

        {/* SECTION 3: Bottom Copyright and Credits (Argon Footer 3 Style) */}
        <Row className={`${styles.footerRow} md-between`}>
          <Col md="6" className="text-center text-md-left">
            <div className="copyright">
              © Made with &hearts; by :
            </div>
          </Col>
          <Col md="6">
            <Nav className={`${styles.linksList} justify-content-center justify-content-md-end`}>
              <NavItem>
                <NavLink href="mailto:jennifer.correiab@gmail.com" target="_blank" className={styles.footerLinks}>
                  Design: Jennifer Correia
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://github.com/christellec64" target="_blank" rel="noopener noreferrer" className={styles.footerLinks}>
                  Dev: Christelle Conrozier
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
